import * as React from "react";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

/** FaqBlockElement */
interface FaqBlockElementProps extends FaqBlockQuestion {
  activeElementIndex: number
  elementIndex: number
  selectElement: (elementIndex: number) => any
}

const FaqBlockElement = (props: FaqBlockElementProps) => {
  const {activeElementIndex,elementIndex,selectElement,elementQuestion,elementAnswer,elementButtonLinkTo} = props;
  const isActive: boolean = activeElementIndex == elementIndex;

  // SPRAWDZANIE CZY OPIS JEST LISTĄ
  const elementAnswerIsAList: boolean = Array.isArray(elementAnswer);

  // ZWRACANIE DANYCH
  return (
    <div className="panel panel-default">
      <PanelHeadingWrapper className="panel-heading" onClick={() => selectElement(elementIndex)}>
        <PanelTitleWrapper className="panel-title">
          <a>{elementQuestion}</a>
        </PanelTitleWrapper>
      </PanelHeadingWrapper>
      <div className={"panel-collapse collapse in"}>
        <PanelBodyWrapper className="panel-body">
          {!elementAnswerIsAList && elementAnswer}
          {elementAnswerIsAList && (elementAnswer as string[]).map((answerPart: string, i: number) => <div key={i} className="answer-part">{answerPart}</div>)}
          {elementButtonLinkTo && <a href={elementButtonLinkTo} target="_blank" className="btn btn-sm waves-effect waves-light mt-20">Więcej</a>}
        </PanelBodyWrapper>
      </div>
    </div>
  )
};

/** STYLES => FaqBlockElement */

const PanelHeadingWrapper = styled.div`
  background-image: none !important;
`;

const PanelTitleWrapper = styled.h3`
  line-height: 17.6px !important;
`;

const PanelBodyWrapper = styled.div`
`;

/** FaqBlock */
interface FaqBlockProps {
  /** PYTANIA DO FAK */
  faqQuestions: FaqBlockQuestion[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TO TRIGGER ON FAQ QUESTION VIEW */
  faqQuestionReadEventType?: GoogleAnalyticsEventType
}

interface FaqBlockState {
  activeElementIndex: number
}

class FaqBlock extends React.Component<FaqBlockProps,FaqBlockState> {

  constructor(props: FaqBlockProps) {
    super(props);
    this.state = {
      activeElementIndex: 1,
    };
    this.onComponentView = this.onComponentView.bind(this);
    this.onFaqQuestionSelect = this.onFaqQuestionSelect.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onFaqQuestionSelect(index: number) {
    // ZAZNACZANIE I ODZNACZANIE
    const {activeElementIndex} = this.state;
    if (index == activeElementIndex) {
      this.setState({activeElementIndex: 0});
    } else {
      this.setState({activeElementIndex: index});
    }

    // GOOGLE EVENT
    if (this.props.faqQuestionReadEventType) {
      googleAnalyticsService.trackEvent(this.props.faqQuestionReadEventType);
    }
  }

  render() {
    const {faqQuestions} = this.props;
    const {activeElementIndex} = this.state;
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <FaqBlockWrapper className="section-padding">
          <div className="container">

            <FaqBlockElementsWrapper className="row">
              <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                <div className="panel-group flat-accordion brand-accordion z-depth-1">
                  {faqQuestions.map((faqQuestion: FaqBlockQuestion, index: number) =>
                    <FaqBlockElement
                      key={index}
                      activeElementIndex={activeElementIndex}
                      elementIndex={index + 1}
                      selectElement={this.onFaqQuestionSelect}
                      {...faqQuestion}
                    />
                  )}
                </div>
              </div>
            </FaqBlockElementsWrapper>

          </div>
        </FaqBlockWrapper>
      </div>
    )
  }

}

/** STYLES => FaqBlock */

const FaqBlockWrapper = styled.section`
  margin-top: -20px;
  padding-top: 0px !important;
  padding-bottom: 40px !important;
`;

const FaqBlockElementsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default FaqBlock


// WEBPACK FOOTER //
// ./src/layouts/faq-block/faq-block.tsx